import Paper from '@material-ui/core/Paper';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { color } from '../../app/theme';
import IconDelete from '../../assets/images/Icons/IconDelete';
import IconEdit from '../../assets/images/Icons/IconEdit';
import TextAreaCard from './TextAreaCard';

const useStyles = makeStyles(
  () => ({
    label: {
      position: 'relative',
      padding: '0 8px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: color.$8,
      },
      justifyContent: 'space-between',
      fontFamily: 'PingFang TC',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '18px',
      color: color.$14,
    },
    subtitle: {
      color: color.$11,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    paper: {
      borderRadius: '12px',
      boxShadow:
        '0 16px 48px 0 rgba(0, 0, 0, 0.07), 0 6px 18px 0 rgba(0, 0, 0, 0.03)',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      padding: '24px',
      width: '304px',
    },
    edit: {
      marginBottom: '12px',
      color: color.$3,
      fontFamily: 'PingFang TC',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '15px',
    },
    saveContainer: {
      display: 'flex',
      justifyContent: 'right',
      marginTop: '12px',
    },
    save: {
      color: color.$2,
      textAlign: 'right',
      fontFamily: 'PingFang TC',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '15px',
    },
  }),
  {
    name: 'ItemLabel',
  },
);

function ItemLabel({
  title,
  subtitle,
  editTitle,
  saveTitle,
  isEditable,
  isDeleteable,
  onClick = () => {},
  onEditClick = () => {},
  onDeleteClick = () => {},
}) {
  const classes = useStyles();
  const [isHover, setIsHover] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [localTitle, setLocalTitle] = useState(title);
  const [isModified, setIsModified] = useState(false);
  const paperRef = useRef(null);

  const handleClickOutside = e => {
    if (paperRef.current && !paperRef.current.contains(e.target)) {
      setIsEdit(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={classes.label}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={onClick}
    >
      <div>
        <span>{title}</span>
        <span className={classes.subtitle}>{subtitle}</span>
      </div>
      {isHover && (
        <div className={classes.iconContainer}>
          {isEditable && (
            <IconEdit
              id="item-label-icon-edit"
              color={color.$10}
              hoverColor={color.$1}
              width={20}
              height={20}
              onClick={() => {
                setIsEdit(true);
              }}
            />
          )}
          {isDeleteable && (
            <IconDelete
              id="item-label-icon-delete"
              hoverColor={color.$1}
              width={20}
              height={20}
              onClick={onDeleteClick}
            />
          )}
        </div>
      )}
      {isEdit && (
        <Paper className={classes.paper} ref={paperRef}>
          <div className={classes.edit}>{editTitle}</div>
          <TextAreaCard
            maxCount={24}
            value={localTitle}
            onChange={v => {
              setLocalTitle(v);
              setIsModified(true);
            }}
            status={isModified && localTitle === '' ? 'error' : undefined}
          />
          <div className={classes.saveContainer}>
            <div
              className={classes.save}
              onClick={e => {
                setIsEdit(false);
                onEditClick(e, localTitle);
              }}
            >
              {saveTitle}
            </div>
          </div>
        </Paper>
      )}
    </div>
  );
}

ItemLabel.defaultProps = {
  title: '',
  subtitle: '',
  editTitle: '',
  saveTitle: '',
  isEditable: false,
  isDeleteable: false,
};

ItemLabel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  editTitle: PropTypes.string,
  saveTitle: PropTypes.string,
  isEditable: PropTypes.bool,
  isDeleteable: PropTypes.bool,
};

export default ItemLabel;
